module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/core/components/confirm-dialog/confirm-dialog.component.scss
// module id = ./src/app/core/components/confirm-dialog/confirm-dialog.component.scss
// module chunks = main